import { render, staticRenderFns } from "./clientManageAgentFrame.vue?vue&type=template&id=e79761bc&scoped=true"
import script from "./clientManageAgentFrame.vue?vue&type=script&lang=js"
export * from "./clientManageAgentFrame.vue?vue&type=script&lang=js"
import style0 from "./clientManageAgentFrame.vue?vue&type=style&index=0&id=e79761bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79761bc",
  null
  
)

export default component.exports